export * from './window.token';
